// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fade-in-enter-active[data-v-7905ec42],
.fade-in-leave-active[data-v-7905ec42] {
  transition: opacity 0.1s ease-out;
}
.fade-in-enter-from[data-v-7905ec42],
.fade-in-leave-to[data-v-7905ec42] {
  opacity: 0;
}
.slide-in-enter-active[data-v-7905ec42],
.slide-in-leave-active[data-v-7905ec42] {
  transition: transform 0.3s ease;
}
.slide-in-enter-from[data-v-7905ec42],
.slide-in-leave-to[data-v-7905ec42] {
  transform: translateY(100%);
}
@media (min-width: 768px) {
.slide-in-enter-from[data-v-7905ec42],
  .slide-in-leave-to[data-v-7905ec42] {
    transform: translateX(100%);
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
